import { render } from "./InsightCharts.vue?vue&type=template&id=5c90d9f0"
import script from "./InsightCharts.vue?vue&type=script&lang=js"
export * from "./InsightCharts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__